import { PlusOutlined } from "@ant-design/icons";
import { Col, Form, Input, Modal, Row, Select, Upload, Button } from "antd";
import { add } from "lodash";
import { useState } from "react";
import { toast } from "react-toastify";
import { getBase64, getPhotoUrl } from "utils/common";
import { formItemLayoutHorizontal } from "utils/constants";

function PlaceDetailModal(props) {
  const [form] = Form.useForm();
  const { open, isProcessing, onSubmit, onCancel, place } = props;
  const [imageUrl, setImageUrl] = useState(
    getPhotoUrl(place?.image?.path || null, "w=200&h=102")
  );
  const [image, setImage] = useState(null);

  const initialValues = place
    ? {
        ...place,
      }
    : {
        name: "",
        address: "",
        long: 105.000001,
        lat: 21.000001,
        priority: 99,
        active: true,
      };

  const onOK = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        const place = { ...initialValues, ...values };

        Object.entries({
          data: JSON.stringify(place),
          image,
        }).forEach(([key, value]) => {
          formData.append(key, value);
        });

        delete place.time;

        onSubmit(place, formData);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const beforeUpload = async (file) => {
    const validType =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/webp";
    if (!validType) {
      toast.error("Chỉ chấp nhận file ảnh!");
    } else {
      const preview = await getBase64(file);
      setImageUrl(preview);
      setImage(file);
    }
    return false;
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Modal
      title="Địa điểm gợi ý"
      okText="Lưu"
      cancelText="Huỷ"
      centered
      open={open}
      onOk={onOK}
      onCancel={onCancel}
      confirmLoading={isProcessing}
      width={800}
    >
      <Form
        {...formItemLayoutHorizontal}
        form={form}
        initialValues={initialValues}
      >
        <Form.Item
          name="name"
          label="Tên địa điểm"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <Input placeholder="Tên địa điểm" />
        </Form.Item>
        <Form.Item
          name="address"
          label="Địa chỉ"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <Input placeholder="Địa chỉ cụ thể của địa điểm" />
        </Form.Item>
        <Form.Item label="Tọa độ" style={{ marginBottom: 0 }}>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item name="long">
                <Input addonBefore="Kinh độ" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="lat">
                <Input addonBefore="Vĩ độ" />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item name="priority" label="Thứ tự ưu tiên">
          <Input type={"number"} min={0} />
        </Form.Item>
        <Form.Item label="Hình ảnh">
          <Upload
            accept={"image/*"}
            name="image"
            listType="picture-card"
            className="avatar-uploader-cover"
            showUploadList={false}
            beforeUpload={beforeUpload}
          >
            {imageUrl ? (
              <img src={imageUrl} alt="image" style={{ width: "100%" }} />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item
          name="active"
          label="Trạng thái"
          rules={[{ required: true }]}
        >
          <Select placeholder="--Trạng thái--">
            <Select.Option value={true}>Active</Select.Option>
            <Select.Option value={false}>In-active</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PlaceDetailModal;
